module.exports = __webpack_public_path__ + "static/media/newspapers.0151f172.jpg";